const validate = (value, [length]) => {
    if (value === undefined || value === null) {
        return false;
    }

    if (Array.isArray(value)) {
        return value.every(val => validate(val, [length]));
    }

    const parsed = new DOMParser().parseFromString(value, 'text/html');
    const stripped = parsed.body.textContent || '';

    return String(stripped).length >= length;
};

export {
    validate,
};

export default {
    validate,
};



// WEBPACK FOOTER //
// ./src/global/validation/rules/MinStrippedLength.js